import * as React from 'react'
import * as BaseControls from '../common/BaseControls';
import { ISystemBase } from 'library/types/ISystemBase';
import { ISystemState } from 'library/types/ISystemState';
import { SystemBase } from 'library/common/SystemBase';
import { HttpService } from 'library'
import { MultiSelect } from '@progress/kendo-react-dropdowns';

interface ISystemMultiSelect  {
    minLength?: number,              // minimum length of the input
    maxLength?: number,              // maximum length of the input
    capitalize?: boolean,            // capitalize input 
    className?: string,
    dataSource?: string,
    idField? :string,
    displayField?: string,
}


interface itemType {
    id: number;
    text: string;
}

interface multiselectState {
    itemList: itemType[],
    valueList: itemType[],
    isDataFetched: boolean
}
export default class SystemMultiSelect extends SystemBase<ISystemMultiSelect, multiselectState>
{
   

    constructor(props: any) {
        super(props)
        this.setState({ itemList: [], valueList: [], isDataFetched: false })
       
    }

    componentDidMount = () => {
        this.fetchData(() => this.setValues(this.props.value as string))
    }

    componentDidUpdate = (prevProps: any) => {
      
        if (prevProps.dataSource != this.props.dataSource)
            this.fetchData(() => this.setValues(this.props.value as string))

        else if (prevProps.value != this.props.value)
            this.setValues(this.props.value as string);
    }
    
    fetchData = (onSuccess: any) => {
       
        if (this.props.dataSource) {
            HttpService
                .get(this.props.dataSource)
                .then((response: any) => {
                    // create list of items
                    let _itemList: itemType[] = [];

                    response.data.forEach((item: any) => {
                        if (this.props.idField != undefined && this.props.displayField != undefined &&
                            item[this.props.idField] != undefined && item[this.props.displayField] != undefined)
                            _itemList.push({ id: item[this.props.idField], text: item[this.props.displayField] })
                    })

                    this.setState({ itemList: _itemList, isDataFetched: true }, () => onSuccess())

                }).catch((error) => { });
        }
    }

    setValues = (value: string) => {
        let _selectedList: itemType[] = [];

        // create list of selected values
        if (this.props.value) {
            let s: string = value;
            if (s && s.split(",").length > 0 && this.state.itemList && this.state.itemList.length > 0) {
                s.split(',').map((id: any) => {
                    let itemFound = this.state.itemList.find((t: itemType) => t.id == id);
                    if (itemFound != undefined && itemFound != null) _selectedList.push({ id: itemFound.id, text: itemFound.text });
                })
            }
        }

       
        this.setState({ valueList: _selectedList })
    }

    getValues = (): string  => {
        let result: string = "";
        this.state.valueList.map((item, index) => result += item.id + (index != this.state.valueList.length-1 ? ',' : ''));
        return result;
    }

    onChange = (event: any) => {

        this.setState({
            valueList: [...event.target.value]
        }, () => {
                if (this.props.onChange) {
                    this.props.onChange(event, event.target.name, this.getValues())
                }
            });

    }

    render() {
        return (
            <this.WrapperDiv>
                <MultiSelect
                    id={this.props.id}
                    name={this.props.name}
                    data={this.state.itemList}
                    textField="text"
                    dataItemKey="id"
                    value={this.state.valueList}
                    disabled={this.props.disabled}
                    onChange={this.onChange} />
            </this.WrapperDiv>
        );
    }
}

